import { http } from '@/api/Connect';
import { BASE_GAME_CENTER_OPERATOR } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import {
  IJackpotCampaignListParams,
  IJackpotCampaignListResponse,
  IJackpotCampaignDetails,
  IJackpotCampaignCreatePayload,
  EJackpotCampaignStatusType
} from '@/api/schema';

const API_JACKPOTS = {
  CAMPAIGNS_LIST(): string {
    return `${BASE_GAME_CENTER_OPERATOR()}/jackpots`; //GET
  },
  CAMPAIGN_DETAILS(id: string | number): string {
    return `${BASE_GAME_CENTER_OPERATOR()}/jackpots/${id}`; //GET
  },
  CREATE_CAMPAIGN(): string {
    return `${BASE_GAME_CENTER_OPERATOR()}/jackpots`; //POST
  },
  UPDATE_CAMPAIGN(id: string | number): string {
    return `${BASE_GAME_CENTER_OPERATOR()}/jackpots/${id}`; //PATCH
  },
  UPDATE_CAMPAIGN_STATUS(id: string | number): string {
    return `${BASE_GAME_CENTER_OPERATOR()}/jackpots/${id}/status`; //PATCH
  }
};

export async function getCampaignsList(
  params: IJackpotCampaignListParams
): Promise<IJackpotCampaignListResponse> {
  return http
    .get(API_JACKPOTS.CAMPAIGNS_LIST(), {
      params,
      cacheTime: 0,
      paramsSerializer: {
        indexes: null
      }
    })
    .then(({ data }: AxiosResponse<IJackpotCampaignListResponse>) => data);
}

export async function getCampaignDetails(
  campaignId: number | string
): Promise<IJackpotCampaignDetails> {
  return http
    .get(API_JACKPOTS.CAMPAIGN_DETAILS(campaignId), {
      cacheTime: 0
    })
    .then(({ data }: AxiosResponse<IJackpotCampaignDetails>) => data);
}

export async function createCampaign(
  payload: IJackpotCampaignCreatePayload
): Promise<IJackpotCampaignDetails> {
  return http
    .post(API_JACKPOTS.CREATE_CAMPAIGN(), payload)
    .then(({ data }: AxiosResponse<IJackpotCampaignDetails>) => data);
}

export async function updateCampaign(
  campaignId: number | string,
  payload: IJackpotCampaignCreatePayload
): Promise<IJackpotCampaignDetails> {
  return http
    .patch(API_JACKPOTS.UPDATE_CAMPAIGN(campaignId), payload)
    .then(({ data }: AxiosResponse<IJackpotCampaignDetails>) => data);
}

export async function updateCampaignStatus(
  campaignId: number | string,
  status: EJackpotCampaignStatusType
): Promise<IJackpotCampaignDetails> {
  return http
    .patch(API_JACKPOTS.UPDATE_CAMPAIGN_STATUS(campaignId), null, {
      params: { status }
    })
    .then(({ data }: AxiosResponse<IJackpotCampaignDetails>) => data);
}
